export default "__VITE_ASSET__DZp3r8BV__"